import React from 'react';
import { Header, SubFooter } from 'Atoms/';
import { Change } from 'Molecules/';

export default function change() {
  return (
    <div>
      <Header
        classType="header-int"
        title1="Diamond Head"
        title2="State Monument"
        url="diamondhead"
      />
      <Change url="diamondhead" parkid="61b977bae43345bd027d7bec" />
      <SubFooter name="Diamond Head State Monument" url="diamondhead" />
    </div>
  );
}
